var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinMapGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 40C15 40 30 29.8734 30 14.6835C30 6.57405 23.2843 0 15 0C6.71573 0 0 6.57405 0 14.6835C0 29.3671 15 40 15 40ZM15 22C18.3137 22 21 19.3137 21 16C21 12.6863 18.3137 10 15 10C11.6863 10 9 12.6863 9 16C9 19.3137 11.6863 22 15 22Z",
    fill: "#7fc128"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinMapGreen);
export default __webpack_public_path__ + "static/media/pinMapGreen.b0bbc726f57f1ae6d9bd0ba8f935a9af.svg";
export { ForwardRef as ReactComponent };